import * as React from 'react';
import styled from 'styled-components';

import { loadJSData } from '../shared/jsData';
import t from '../shared/translations';

const Main = styled.main`
    max-width: 1000px;
    padding: 0 15px;
    margin: 0 auto;
`;

function Start(): JSX.Element {
    return <Main id='index-page' className='text-center'>
        <h1>{t('public.index.heading')}</h1>
        <div>
            <img src='/static/images/avatar/male-1-jumping.png' />
            <img src='/static/images/avatar/female-1-jumping.png' />
        </div>
        <a href='/login' className='button'>{t('public.index.button-play')}</a>
        <p>
            <img src={loadJSData().settings.logo_src} alt='Logo' className='logo' /><br />
            {loadJSData().show_secondary_logo && <>
                <img
                    src='/static/images/TalentMiles-logo-liggande.svg'
                    alt='TalentMiles Logo'
                    className='small-logo'
                />
                <br />
            </>}
            {t('public.index.info-rights')}
        </p>
    </Main>;
}

export default Start;
